import { Injectable } from '@angular/core';
import { RecordService } from './record.service';

interface Response {
  code: string;
  message: string | any;
}

@Injectable({
  providedIn: 'root',
})
export class RecordAdapterService {
  constructor(private readonly recordService: RecordService) {}

  public async getListValidatorAdapter(idCompany: number, idTransaction: string): Promise<Response> {
    try {
      const response = await this.recordService.getListValidatorsByCompanyAndTransaction(idCompany, idTransaction);
      const LIST_VALIDATORS = {
        'validateCurp' : 'CURP',
        'validateNominal':'INE / Lista nominal',
        'validateSat' : '69B (SAT)',
        'validateOfac' : 'OFAC',
        'validatePeps' : 'PEPS',
        'validateFace' : 'Comparación ID vs Selfie',
        'validateGeo' : 'Geolocalización',
        'validateFraud' : 'Correo Electrónico',
        //validateFraud : 'Número Telefónico',
        //validateFraud : 'Dirección IP',
        'validateDeduplication' : 'De-duplicación biométrica',
        'validateIneFingers' : 'Verificación INE - Huellas',
        'validateIneFace' : 'Verificación INE - Rostro',
        "processConfirmation" : 'Confirmación manual exitosa'
      }
      if (response) {
        let listValidators = [];
        for (let key in response) {
          let value = response[key];
          const SECTION = LIST_VALIDATORS[key];
          if (value && SECTION) {
            listValidators.push({
              section: SECTION,
              value,
            });
          }
        }

        const listFilter = listValidators.filter((item) => {
          return (
            item.section !== 'companyId' &&
            item.section !== 'userId' &&
            item.section !== 'creationDate' &&
            item.section !== 'modificationDate'
          );
        });
        return {
          code: 'OPERATION_SUCCEEDED',
          message: listFilter,
        };
      }
    } catch (error) {
      return {
        code: 'OPERATION_FAILED',
        message: 'Error al obtener lista de validaciones para esta compania',
      };
    }
  }

  public async getConfigurationCompany(idCompany: number, idTransaction: string):Promise<Response>{
    try {
      const response = await this.recordService.getListValidatorsByCompanyAndTransaction(idCompany, idTransaction);
      if(response){
        let listValidators = [];
        for (let key in response) {
          let value = response[key];
          if (value) {
            listValidators.push({
              section: key,
              value,
            });
          }
        }
        const listFilter = listValidators.filter((item) => {
          return (
            item.section !== 'companyId' &&
            item.section !== 'userId' &&
            item.section !== 'creationDate' &&
            item.section !== 'modificationDate'
          );
        });
        return {
          code: 'OPERATION_SUCCEEDED',
          message: {
            validators: listFilter,
            listComplete: response
          }
        };
      }else{
        return {
          code: 'OPERATION_FAILED',
          message: 'Error al obtener lista de validaciones para esta compania',
        };
      }
    } catch (error) {
      return {
        code: 'OPERATION_FAILED',
        message: 'Error al obtener lista de validaciones para esta compania',
      };
    }
  }


  public async getConfigCompTransParent(idCompany: string, idTransaction: string, idSectionParent: string):Promise<Response>{
    try {
      const response = await this.recordService.getConfigCompTransParent(idCompany, idTransaction, idSectionParent);
      if(response){
        console.log(response);
        return response?.sections;
      }else{
        return {
          code: 'OPERATION_FAILED',
          message: 'Error al obtener lista de validaciones para esta compania',
        };
      }
    } catch (error) {
      return {
        code: 'OPERATION_FAILED',
        message: 'Error al obtener lista de validaciones para esta compania',
      };
    }
  }

}
